// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__QxkkB","arrow-left":"Tooltip_arrow-left__jH_8V","arrow-top":"Tooltip_arrow-top__mSJs3","content":"Tooltip_content__MBUzN"};